import axios from "axios";

const axiosInstance = () => {
  const instance = axios.create({
    baseURL: `${process.env.REACT_APP_DB_PORT}/`,
    headers: {
      "Content-Type": "application/json",
      'content-Type': 'application/json',
      "Accept": "/",
      "Cache-Control": "no-cache",
    },
    credentials: "same-origin",
    withCredentials: true
  });

  // intercept the response of api endpoints
  instance.interceptors.response.use((response) => {

    return response;

    }, (error) => {

      if(error.response.status === 401) {

        window.location.href = `${window.location.origin}/#/Auth/login/`;

        error.data.success = false;

        return Promise.reject(error);
      }

      return Promise.reject(error);
    }
  );

  return instance;
};

export default axiosInstance;